import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";
import { DateTime } from "luxon";

export const sortEventsByDate = (events) => {
  const list = [...events] || [];
  return list.sort((a, b) => {
    // if eventDate is an object get the start date
    const aStart =
      typeof a.eventDate === "object" ? a.eventDate.start : a.eventDate;
    const bStart =
      typeof b.eventDate === "object" ? b.eventDate.start : b.eventDate;

    return new Date(aStart).valueOf() - new Date(bStart).valueOf();
  });
};

export const getCurrentLocation = async (opts = {}) => {
  opts.setLoading && opts.setLoading(true);
  try {
    if (Capacitor.getPlatform() === 'web' && 'geolocation' in navigator) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coords = position.coords;
            if (opts.setLocation) {
              opts.setLocation({
                lat: coords.latitude,
                lng: coords.longitude,
              });
            }
            opts.setLoading && opts.setLoading(false);
            resolve(coords);
          },
          (error) => {
            opts.setLoading && opts.setLoading(false);
            if (opts.default) {
              resolve(opts.default);
            } else {
              reject(error);
            }
          }
        );
      });
    }

    // Native (iOS/Android) path
    const { location: permissionStatus } = await Geolocation.checkPermissions();
    if (permissionStatus !== 'granted') {
      const { location: newPermission } = await Geolocation.requestPermissions();
      if (newPermission !== 'granted') {
        throw new Error('Location permission denied');
      }
    }
    const position = await Geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      ...(opts?.options || {}),
    });
    const coords = position.coords;
    if (opts.setLocation) {
      opts.setLocation({
        lat: coords.latitude,
        lng: coords.longitude,
      });
    }
    return coords;
  } catch (error) {
    console.error('Error getting location:', error);
    if (opts.default) {
      return opts.default;
    }
    // throw error;
  } finally {
    opts.setLoading && opts.setLoading(false);
  }
};

export const formatPosterAccount = (account, color = "var(--inyc-primary-text-color)",onClick) => {
  let formatedAccountName = "";
  let formattedAccountUsername = ``;
  if (account.accountType === "business") {
    formattedAccountUsername +=
      (account.businessName || account.firstName + " " + account.lastName);
    formatedAccountName = "business"
  } else if (account.accountType === "artist") {
    formattedAccountUsername +=
      account.businessName || `${account.firstName || ""} ${account.lastName || ""}`.trim();
    formatedAccountName = "artist: ";
  } else {
    formattedAccountUsername +=
      account.firstName + " " + account.lastName;
    formatedAccountName += ""
  }
  if(onClick) {
    return <>
    by {formatedAccountName} <span 
    className="cursor-pointer duration-300 hover:!text-[var(--inyc-primary-text-color)]"
    onClick={onClick} style={{color:color,

      fontFamily: 'Primary-Regular'
    }}>{formattedAccountUsername}</span>
    </>
  }
  return "by" + formatedAccountName;
};

export const defaultDateFilter = (timezone, opts = {}) => {
  
  const date = {
    start: DateTime.now()
      .setZone(timezone)
      .startOf("day")
      .setZone("local", {
        keepLocalTime: true,
      })
      .toJSDate(),
    end: DateTime.now()
      .plus(
        opts.endPlus || {
          days: 2,
        }
      )
      .setZone(timezone)
      .startOf("day")
      .setZone("local", {
        keepLocalTime: true,
      })
      .toJSDate(),
  };

  return date;
};
